import { render, staticRenderFns } from "./KStartsOrganizersList.vue?vue&type=template&id=094517dd&"
import script from "./KStartsOrganizersList.vue?vue&type=script&lang=js&"
export * from "./KStartsOrganizersList.vue?vue&type=script&lang=js&"
import style0 from "./KStartsOrganizersList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports